export const NUMBER_OF_DAYS_FOR_FORECAST_IN_FUTURE = 7;
export const MAX_NUMBER_OF_DAYS_FOR_FORECAST =
  NUMBER_OF_DAYS_FOR_FORECAST_IN_FUTURE + 1; // Today + next x days

export const WIND_DIRECTIONS = [
  { range: [-1], translationKey: "a11yMovingWind" },
  { range: [0], translationKey: "a11yNorthWind" },
  { range: [1, 89], translationKey: "a11yNortheastWind" },
  { range: [90], translationKey: "a11yEastWind" },
  { range: [91, 179], translationKey: "a11ySoutheastWind" },
  { range: [180], translationKey: "a11ySouthWind" },
  { range: [181, 269], translationKey: "a11ySouthwestWind" },
  { range: [270], translationKey: "a11yWestWind" },
  { range: [271, 359], translationKey: "a11yNorthwestWind" },
  { range: [360], translationKey: "a11yNorthWind" },
];
